import(/* webpackMode: "eager" */ "/vercel/path0/app/immobilier/page.tsx");
